const funfacts = [
    "The Eiffel Tower can be 15 cm taller during the summer.",
    "20% of Earth’s oxygen is produced by the Amazon rainforest.",
    "Some metals are so reactive that they explode on contact with water.",
    "A teaspoonful of neutron star would weigh 6 billion tons.",
    "Hawaii moves 7.5cm closer to Alaska every year.",
    "Chalk is made from trillions of microscopic plankton fossils.",
  ];
  
  export default funfacts;
  